
import { IconArrowRight, IconCheck, IconCalendar, IconUsers } from "@tabler/icons-react";

const Home = () => {
    // Randomize background image from main1.webp to main8.webp
    const randomImageNumber = Math.floor(Math.random() * 2) + 1;
    const backgroundImage = `/img/main${randomImageNumber}.webp`;

    return (
        <div className="min-h-screen flex flex-col">
            {/* Header */}

            <header className="bg-white shadow-sm border-b border-gray-200">
                <div className="max-w-7xl mx-auto px-2 sm:px-4 lg:px-8">
                    <div className="flex justify-between items-center h-14 sm:h-16">
                        <div className="flex items-center">
                            <img src="/img/3h.png" alt="Logo" className="w-8 h-8 sm:w-10 sm:h-10 mr-2 sm:mr-3" />
                            <h1 className="text-base sm:text-xl font-bold text-gray-900">SCVČ Tri Hôrky</h1>
                        </div>
                        <nav className="flex space-x-2 sm:space-x-4">
                            <a href="/admin" className="text-xs sm:text-sm text-gray-600 hover:text-gray-900 transition-colors">
                                Administrácia
                            </a>
                        </nav>
                    </div>
                </div>
            </header>

            {/* Hero Section */}
            <div className="relative overflow-hidden bg-gradient-to-br flex-1 from-blue-50 to-indigo-100" style={{ backgroundImage: `url(${backgroundImage})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
                <div className="absolute inset-0 bg-indigo-100/80"></div>
                <div className="relative max-w-8xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-16">

                    {/* subtle overlay to replicate previous opacity effect */}
                    <div className="text-center">
                        <img src="/img/3h.png" alt="Logo" className="w-20 h-20 sm:w-32 sm:h-32 mx-auto mb-6 sm:mb-8" />
                        <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900">
                            Prihlasovanie na školský rok 2026/27 je spustené!
                        </h1>
                        <p className="mt-3 max-w-md mx-auto text-sm sm:text-base lg:text-lg text-gray-600 md:mt-5 md:max-w-3xl px-4">
                            Jednoducho sa prihláste a spravujte vaše prihlášky.
                        </p>
                        <div className="mt-6 sm:mt-8 max-w-md mx-auto px-4 sm:flex sm:justify-center">
                            <div className="rounded-md shadow">
                                <a
                                    href="/user-login"
                                    className="w-full flex items-center justify-center px-6 sm:px-8 py-3 border border-transparent text-sm sm:text-base font-medium rounded-md text-white bg-primary hover:bg-red-700 md:py-4 lg:text-lg md:px-10 transition-colors duration-200"
                                >
                                    Prihlásiť sa
                                    <IconArrowRight className="ml-2 h-4 w-4 sm:h-5 sm:w-5" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Features Section */}
            <div className="py-12 sm:py-16 bg-white ">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center">
                        <h2 className="text-2xl sm:text-3xl font-extrabold text-gray-900">
                            O nás
                        </h2>
                        <p className="mt-4 max-w-4xl mx-auto text-base sm:text-xl text-gray-600">
                            Sme Súkromné centrum voľného času, určené pre deti, mladých i pre celú rodinu.
                            Zastrešujeme aktivity saleziánov a DOMKY v stedisku Košice - Tri hôrky.
                        </p>
                    </div>

                    <div className="mt-12 sm:mt-16">
                        <div className="grid grid-cols-1 gap-8 sm:gap-12 md:grid-cols-2 lg:grid-cols-3">
                            <div className="text-center px-4">
                                <div className="flex items-center justify-center h-16 w-16 rounded-full bg-primary text-white mx-auto mb-6">
                                    <IconUsers className="h-8 w-8" />
                                </div>
                                <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-4">Priestor pre stretávanie</h3>
                                <p className="text-base text-gray-600 leading-relaxed">
                                    Vytvárame priestor pre stretávanie, rozvíjanie talentov a tvorivých schopností,
                                    kde môžete nadväzovať nové kamarátstva.
                                </p>
                            </div>

                            <div className="text-center px-4">
                                <div className="flex items-center justify-center h-16 w-16 rounded-full bg-primary text-white mx-auto mb-6">
                                    <IconCalendar className="h-8 w-8" />
                                </div>
                                <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-4">Kreatívne trávenie času</h3>
                                <p className="text-base text-gray-600 leading-relaxed">
                                    Prichádzajú k nám deti, mladí, ich rodičia aj iní návštevníci,
                                    aby spoločne a kreatívne trávili voľný čas.
                                </p>
                            </div>

                            <div className="text-center px-4 md:col-span-2 lg:col-span-1">
                                <div className="flex items-center justify-center h-16 w-16 rounded-full bg-primary text-white mx-auto mb-6">
                                    <IconCheck className="h-8 w-8" />
                                </div>
                                <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-4">Rozvoj záľub a učenie</h3>
                                <p className="text-base text-gray-600 leading-relaxed">
                                    Môžete sa venovať svojim záľubám, spoznávať a učiť sa niečo nové
                                    v priateľskom a podporujúcom prostredí.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer */}
            <footer className="bg-gray-800">
                <div className="max-w-7xl mx-auto py-6 sm:py-8 px-4 sm:px-6 lg:px-8 flex justify-center gap-16">
                    <a href="https://3horky.sk" target="_blank" rel="noreferrer" className="text-center text-xs sm:text-sm text-gray-400">
                        © 2025 <span className="underline text-xs sm:text-sm">Tri Hôrky</span>
                    </a>
                    <a href="https://studioeastwave.com" target="_blank" rel="noreferrer" className="text-center text-xs sm:text-sm text-gray-400 ">
                        Created by: <span className="underline text-xs sm:text-sm">Studio EastWave</span>
                    </a>
                </div>
            </footer>
        </div>
    );
}

export default Home;